import { render, staticRenderFns } from "./XmMultipleChoice.vue?vue&type=template&id=30cb582a&scoped=true"
import script from "./XmMultipleChoice.vue?vue&type=script&lang=js"
export * from "./XmMultipleChoice.vue?vue&type=script&lang=js"
import style0 from "./XmMultipleChoice.vue?vue&type=style&index=0&id=30cb582a&prod&lang=scss&scoped=true"
import style1 from "./XmMultipleChoice.vue?vue&type=style&index=1&id=30cb582a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cb582a",
  null
  
)

export default component.exports